import api from './api';

// Não precisamos mais do getAuthHeader pois a instância api já adiciona os headers de autenticação

// Interfaces para tipagem
export interface User {
  _id?: string;
  firebaseUid: string;
  email: string;
  displayName?: string;
  photoURL?: string;
  role: 'admin' | 'manager' | 'field-agent' | 'user';
  isActive: boolean;
  lastLogin?: Date;
  metadata?: any;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface UserFormData {
  email: string;
  displayName: string;
  role: 'admin' | 'manager' | 'field-agent' | 'user';
  isActive: boolean;
  firebaseUid?: string;
  photoURL?: string;
  metadata?: any;
}

// Obter todos os usuários
export const getUsers = async (params = {}) => {
  try {
    const response = await api.get('/users', { params });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar usuários:', error);
    throw error;
  }
};

// Obter um usuário pelo ID
export const getUserById = async (userId: string) => {
  try {
    const response = await api.get(`/users/${userId}`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao buscar usuário ${userId}:`, error);
    throw error;
  }
};

// Obter o perfil do usuário atual
export const getCurrentUserProfile = async () => {
  try {
    const response = await api.get('/users/profile');
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar perfil do usuário:', error);
    throw error;
  }
};

// Atualizar o perfil do usuário
export const updateUserProfile = async (profileData: any) => {
  try {
    const response = await api.put('/users/profile', profileData);
    return response.data;
  } catch (error) {
    console.error('Erro ao atualizar perfil do usuário:', error);
    throw error;
  }
};

// Obter técnicos disponíveis
export const getAvailableTechnicians = async () => {
  try {
    const response = await api.get('/users/technicians');
    // Extrair o array de técnicos do objeto de resposta
    return response.data.technicians || [];
  } catch (error) {
    console.error('Erro ao buscar técnicos disponíveis:', error);
    throw error;
  }
};

// Criar um novo usuário
export const createUser = async (userData: UserFormData) => {
  try {
    const response = await api.post('/users', userData);
    return response.data;
  } catch (error) {
    console.error('Erro ao criar usuário:', error);
    throw error;
  }
};

// Atualizar um usuário existente
export const updateUser = async (userId: string, userData: Partial<UserFormData>) => {
  try {
    const response = await api.put(`/users/${userId}`, userData);
    return response.data;
  } catch (error) {
    console.error(`Erro ao atualizar usuário ${userId}:`, error);
    throw error;
  }
};

// Desativar um usuário (soft delete)
export const deleteUser = async (userId: string) => {
  try {
    const response = await api.delete(`/users/${userId}`);
    return response.data;
  } catch (error) {
    console.error(`Erro ao desativar usuário ${userId}:`, error);
    throw error;
  }
};

// Obter usuários comerciais (gerentes)
export const getCommercialAgents = async () => {
  try {
    const response = await api.get('/users/commercial');
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar agentes comerciais:', error);
    throw error;
  }
};

export default {
  getUsers,
  getUserById,
  getCurrentUserProfile,
  updateUserProfile,
  getAvailableTechnicians,
  getCommercialAgents,
  createUser,
  updateUser,
  deleteUser
};
